export enum QueryParams {
  Limit = 'limit',
  Offset = 'offset',
  FilterBy = 'filter_by',
  OrderBy = 'order_by',
  Count = 'count'
}
